// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteria.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Button = require('share/components/controls/Izenda.Button');
  var Input = require('share/components/controls/Izenda.Input');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var DateTimePicker = require('share/components/controls/DateTime/Izenda.DateTimePicker');
  var EventUtils = require('EventUtils');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');

  var TextInput = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var criteria = props.criteria;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {props.label}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <Input
            value={reportPartSelection.getCriteria(criteria)}
            onChange={EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, criteria), EventUtils.INPUT)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var DateInput = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var criteria = props.criteria;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols={2} className="control-label">
          {props.label}
        </GridLayout.Col>
        <GridLayout.Col cols={10}>
          <DateTimePicker
            time={false}
            value={reportPartSelection.getCriteria(criteria)}
            onChange={reportPartSelection.setCriteria.bind(reportPartSelection, criteria)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var SearchDate = connect()(function (props) {
    var localization = props.localization;

    return (
      <GridLayout.Row className="form-horizontal">
        <GridLayout.Col cols={3} className="u_controlHeight control-label">
          {props.label}
        </GridLayout.Col>
        <GridLayout.Col cols={9}>
          <GridLayout.Row>
            <GridLayout.Col cols={6}>
              <DateInput {...props} criteria={props.criteria + 'From'} label={localization.getText('COMMON_LABEL_FROM')} />
            </GridLayout.Col>
            <GridLayout.Col cols={6}>
              <DateInput {...props} criteria={props.criteria + 'To'} label={localization.getText('COMMON_LABEL_TO')} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var SaveInto = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;
    var GLOBAL_CATEGORY_TYPES = [
      { value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.LOCAL, label: reportPartSelectionStore.localReportName },
      { value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.GLOBAL, label: reportPartSelectionStore.globalReportName }
    ];

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {localization.getText('COMMON_LABEL_SAVE_INTO')}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <DropDown options={GLOBAL_CATEGORY_TYPES}
            labelField={'label'}
            valueField={'value'}
            blankOption
            blankOptionText={localization.getText('COMMON_LABEL_ALL')}
            value={reportPartSelection.displayCriteria.isGlobal}
            onChange={EventUtils.notifyChange(reportPartSelectionStore.selectSaveInto.bind(reportPartSelectionStore), EventUtils.DROPDOWN)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var Category = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {localization.getText('DASHBOARD_LABEL_CATEGORY')}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <DropDown options={reportPartSelection.categoryCollection}
            labelField={'name'}
            valueField={'id'}
            blankOption
            blankOptionText={localization.getText('COMMON_LABEL_ALL')}
            value={reportPartSelection.displayCriteria.selectedCategory}
            onChange={EventUtils.notifyChange(reportPartSelectionStore.selectCategory.bind(reportPartSelectionStore), EventUtils.DROPDOWN)}
            disabled={reportPartSelectionStore.isCategoryDisabled}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var SubCategory = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={3} className="u_controlHeight control-label">
          {localization.getText('DASHBOARD_LABEL_SUB_CATEGORY')}

        </GridLayout.Col>
        <GridLayout.Col cols={9}>
          <GridLayout.Row>
            <GridLayout.Col cols={6}>
              <DropDown options={reportPartSelection.subCategoryCollection}
                labelField={'name'}
                valueField={'id'}
                blankOption
                blankOptionText={localization.getText('COMMON_LABEL_ALL')}
                value={reportPartSelection.displayCriteria.selectedSubCategory}
                onChange={EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, 'selectedSubCategory'), EventUtils.DROPDOWN)}
                disabled={reportPartSelectionStore.isSubCategoryDisabled}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  var ButtonGroup = connect()(function (props) {
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var loader = props.loader;
    var localization = props.localization;

    var onSearch = function () {
      loader.startLoading();
      return reportPartSelectionStore.onSearch(props.excludeIds).then(function () {
        props.showResult && props.showResult(true);
      }).finally(loader.endLoading.bind(loader));
    };
    var onReset = function () {
      loader.startLoading();
      return reportPartSelectionStore.reset().finally(loader.endLoading.bind(loader));
    };

    return (
      <div className="izenda-ReportPartSelectionPopup-ActionBar u_fullWidth u_inlineBlock">
        <div className="u_paddingAll izenda-ActionBarRight">
          <Button onClick={onSearch} label={localization.getText('COMMON_LABEL_SEARCH')} />
          <Button onClick={onReset} label={localization.getText('COMMON_LABEL_RESET')} />
        </div>
      </div>
    );
  });

  var SearchCriteria = function (props) {
    var localization = props.localization;
    return (
      <div>
        <GridLayout className="u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col>
              <strong>{localization.getText('SEARCH_RESULT_LABEL_SEARCH_CRITERIA')}</strong>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <SaveInto {...props} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <Category {...props} />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SubCategory {...props} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...props}
                label={localization.getText('REPORTDESIGNER_LABEL_REPORT_NAME')}
                criteria="reportName" />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...props}
                label={localization.getText('COMMON_CRITERIA_CREATED_BY')}
                criteria="createdBy" />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SearchDate {...props} label={localization.getText('COMMON_CRITERIA_CREATED_DATE')} criteria="createdDate" />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...props}
                label={localization.getText('COMMON_CRITERIA_EDITED_BY')}
                criteria="lastEditedBy" />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SearchDate {...props} label={localization.getText('COMMON_CRITERIA_EDITED_DATE')} criteria="lastEditedDate" />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col>
              <ButtonGroup {...props} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  };

  module.exports = connect()(SearchCriteria);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.SearchCriteria.jsx